export { default } from "./useRefreshComponent";
